import { useContext } from 'react'
import { ThemeProviderContext } from '@/providers/theme'

export function useTheme() {
  const context = useContext(ThemeProviderContext)

  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider')
  }

  return {
    theme: context.theme,
    setTheme: context.setTheme,
    resolvedTheme: context.getResolvedTheme(),
  }
}
